import { render, staticRenderFns } from "./main-section-login.vue?vue&type=template&id=6ad12b04&scoped=true"
import script from "./main-section-login.vue?vue&type=script&lang=js"
export * from "./main-section-login.vue?vue&type=script&lang=js"
import style0 from "./main-section-login.vue?vue&type=style&index=0&id=6ad12b04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad12b04",
  null
  
)

export default component.exports